module.exports = __webpack_public_path__ + "static/media/04.eef70611.jpg";